// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-13ZCZ","delimiter":"delimiter-aqFYh","price":"price-1_I6e","clear":"clear-20w_q"};